import request from 'api/request';

export default function destroyUsersRoute(courseId, userIds) {
  return request({
    url: `/courses/${courseId}/users`,
    method: 'DELETE',
    data: { ids: userIds },
  });
}
